/**
 * 작성자 : 박승호
 * 날짜 : 2024.09.12
 * 기능 : 스위치 토글 버튼 컴포넌트 [ Y / N ]
 */

import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  align-items: center;

  label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: inherit !important;
  }

  .label-name {
    min-width: 5.5rem;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 26px;

    & > input[type='checkbox']:disabled + .slider {
      cursor: default;
    }
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--tonal-deep);
    transition: 0.4s;
    border-radius: 34px;
    box-shadow: 0.5px 0.5px 4px 0px rgba(0, 0, 0, 0.25) inset;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    left: 5px;
    bottom: 3px;
    background-color: #fff;
    transition: 0.4s;
    border-radius: 50%;
    box-shadow: 0.5px 0.5px 5px rgba(0, 0, 0, 0.3);
  }

  input:checked + .slider {
    background-color: #3dbc15;
  }

  input:checked + .slider:before {
    transform: translateX(18px);
  }
`;

interface Props {
  label?: string;
  hFor: string;
  state: boolean;
  setState: Dispatch<SetStateAction<boolean>>;
  disabled?: boolean;
}

const SwitchToggle = ({ label, hFor, state, setState, disabled = false }: Props) => {
  const { t } = useTranslation();

  const onChangeToggle = (e: ChangeEvent<HTMLInputElement>) => {
    setState(e.target.checked);
  };

  return (
    <Root>
      <label htmlFor={hFor}>
        {label && <span className='label-name'>{t(label)}</span>}
        <div className='switch'>
          <input type='checkbox' name={hFor} id={hFor} checked={state} onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeToggle(e)} disabled={disabled} />
          <b className='slider round'> </b>
        </div>
      </label>
    </Root>
  );
};

export default SwitchToggle;
